angular.module('bribac.components.testOverview', [
  'pascalprecht.translate',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.components.collapsingBox',
  'bribac.components.cardTestStatus',
  'bribac.components.testDetails'
])

  .component('testOverview', {
    templateUrl: 'test-overview-component.html',
    controller: 'TestOverviewCtrl',
    bindings: {
      test: '<',
        subject: '<',
        collapsed: '<',
        showTestType: '<'
    }
  })

  .controller('TestOverviewCtrl', function(
    TEST_STATE
  ) {
      console.log("TestOverviewCtrl: ", this);
    this.TEST_STATE = TEST_STATE
  })
